module.exports = __webpack_public_path__ + "img/title.fced95bd.png";